import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: 'white',
        SidebarBg: '',
        BreadCrumbs: {},
        isAuthorized: null,
        user: {},
        dictionaries: {
            speakers: [],
        },
        current: {
            session: null,
        },
    },
    mutations: {
        SET_SIDEBAR_DRAWER(state, payload) {
            state.Sidebar_drawer = payload
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.Customizer_drawer = payload
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.SidebarColor = payload
        },
        UPDATE_BREAD_CRUMBS(state, payload = {}) {
            state.BreadCrumbs = Object.assign({}, state.BreadCrumbs, payload);
        }
    },
    getters: {
        breadCrumbs(state) {
            return state.BreadCrumbs;
        },
    },
    actions: {},
})